import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule, MatIconModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  public readonly data = inject(MAT_DIALOG_DATA);
  public readonly dialogRef = inject(MatDialogRef<ConfirmDialogComponent>);

  public heading = 'Confirm Dialog';
  public message = 'Are you sure you want to perform this action?';
  public confirmButtonText = 'Yes';
  public cancelButtonText = 'No';
  public dialogType: 'warning' | 'danger' | 'info' = 'info';
  public iconName = 'help_outline';

  constructor() {
    if (this.data) {
      this.heading = this.data.heading || this.heading;
      this.message = this.data.message || this.message;
      this.confirmButtonText = this.data.buttonText?.confirm || this.confirmButtonText;
      this.cancelButtonText = this.data.buttonText?.cancel || this.cancelButtonText;
      this.dialogType = this.data.type || this.dialogType;
    }
    this.determineIconName();
  }

  private determineIconName(): void {
    if (this.dialogType === 'warning') {
      this.iconName = 'warning';
    } else if (this.dialogType === 'danger') {
      this.iconName = 'delete_outline';
    } else {
      this.iconName = 'help_outline';
    }
  }

  public handleClose(): void {
    this.dialogRef.close(true);
  }
}
